import React, { Component } from "react";
import { withRouter } from "react-router";

import "./partners.scss";

import axios from "axios";

import PartnersFilter from "./partnersFilter";
import PartnersBlock from "./partnersBlock";

import { animateScroll as scroll } from "react-scroll";

import { env } from "../../../shared/environment/index";
import Loading from "../../../shared/components/loading";
import filter from "../../../shared/assets/images/partners/filter.svg";

class Partners extends Component {
    isLoading = false;
    urlPrefix = env.baseUrl;
    isFiltered = false;

    rowsLimit = 48

    constructor(props) {
        super(props);
        this.state = {
            partnersCount: [],
            isAllPartners: false,
            storeQuantity: "",
            loading: false,
            showFilters: false,
            showMoreShopsFlag: false
        };

        this.onFilter = this.onFilter.bind(this);
        this.shuffle = this.shuffle.bind(this);
        this.onShowFilters = this.onShowFilters.bind(this);
        this.showMorePartners = this.showMorePartners.bind(this);

        let urlString = window.location.href;
        let urlStaged = urlString.replace("#/", "");
        let url = new URL(urlStaged);

        let city = url.searchParams.get("cy");
        let category = url.searchParams.get("ce");
        let period = url.searchParams.get("pi");
        let name = url.searchParams.get("ne");
        let type = url.searchParams.get("ty");

        this.filterModel = {
            id: null,
            name: name ? name : "",
            cityID: city ? Number(city) : null,
            periodID: period ? Number(period) : null,
            categoryID: category ? Number(category) : null,
            conditionsTypeID: type ? Number(type) : null,
            rowsLimit: this.rowsLimit,
            rowsOffset: 0,
        };

        if (city || category || period || name || type) {
            this.isFiltered = true;
        }

        this.scrollToTop = this.scrollToTop.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.cityHandler && props.cityHandler === "getPartners") {
            this.filterModel.cityID = localStorage.getItem("city");
            console.log("updated: ", this.filterModel.cityID);
            this.getPartners(this.filterModel);
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        });

        if (this.props.windowWidth > 768) {
            this.setState({
                showFilters: true
            });
        }

        this.getPartners(this.filterModel);
    }

    showMorePartners() {
        this.filterModel.rowsOffset = this.filterModel.rowsOffset + this.rowsLimit;
        this.getPartners(this.filterModel);
    }

    onFilter(event) {
        this.filterModel.rowsOffset = 0
        this.setState({ partnersCount: [] })
        if (event && event.key && event.key === "city") {
            this.filterModel.cityID = event.value.id;
        }

        if (event && event.key && event.key === "category") {
            this.filterModel.categoryID = event.value.id;
        }

        if (event && event.key && event.key === "period") {
            this.filterModel.periodID = event.value.id;
        }

        if (event && event.key && event.key === "type") {
            this.filterModel.conditionsTypeID = event.value.id;
        }

        if (event && event.key && event.key === "partnersName") {
            this.filterModel.name = event.value;
        }

        if (event && event === "clean") {
            this.filterModel = {
                id: null,
                name: "",
                cityID: null,
                periodID: null,
                categoryID: null,
                conditionsTypeID: null,
                rowsLimit: this.rowsLimit,
                rowsOffset: 0
            }
        }
        this.changeQuery(
            this.filterModel.cityID,
            this.filterModel.categoryID,
            this.filterModel.periodID,
            this.filterModel.name,
            this.filterModel.conditionsTypeID
        );
        this.getPartners(this.filterModel);
    }

    changeQuery(cityId, categoryId, periodId, name, conditionsTypeID) {
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: `?${cityId ? "cy=" + cityId + "&" : ""}${categoryId ? "ce=" + categoryId + "&" : ""
                }${periodId ? "pi=" + periodId + "&" : ""}${conditionsTypeID ? "ty=" + conditionsTypeID + "&" : ""
                }${name ? "ne=" + name + "&" : ""}`
        });
    }


    getPartners(filters) {
        this.setState({
            loading: true
        });
        axios({
            method: "post",
            url: `${this.urlPrefix}public/partners`,
            data: filters
        })
            .then(response => {
                if (response && response.data && response.data.code === 200) {
                    if (this.state.partnersCount.length !== 0) {
                        this.setState({
                            partnersCount: [...this.state.partnersCount, ...response.data.payload],
                            loading: false
                        });
                    } else {
                        this.setState({
                            partnersCount: response.data.payload !== null 
                            ? this.shuffle(response.data.payload) 
                            : response.data.payload,
                            storeQuantity: response.data.total,
                            loading: false
                        });
                    }
                }
                if (this.state.partnersCount.length < Number(this.state.storeQuantity)) {
                    this.setState({ showMoreShopsFlag: true })
                } else {
                    this.setState({ showMoreShopsFlag: false })
                }

                this.setState({
                    loading: false
                });
            })
            .catch(response => {
                this.setState({
                    loading: false,
                    partnersCount: [],
                    storeQuantity: 0
                });
                console.log("Error: ", response);
            });
    }




    shuffle(array) {
        if (array.length === 0) {
            return array
        }
        var currentIndex = array && array.length > 0 ? array.length : [];
        var temporaryValue = [];
        var randomIndex = null;

        while (0 !== currentIndex) {

            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    scrollToTop() {
        scroll.scrollToTop();
    }

    onShowFilters() {
        this.setState({
            showFilters: !this.state.showFilters
        })
    }



    render() {

        function storeQuan(value) {
            if (value === 1) {
                return value + ' партнёр';
            }
            if (value <= 4) {
                return value + ' партнёра';
            }
            if (value <= 10) {
                return value + ' партнёров';
            }
            return 'Более ' + parseInt(value / 10, 10) * 10 + ' партнёров';
        };

        const partnersCount = this.state.partnersCount;
        const storeQuantity = this.state.storeQuantity;

        return (
            <div className="partners" id="partnersPageTop">
                {this.state.loading ? <Loading /> : null}
                <div className="container">
                    <div className="ctm-title title-h3 text-left d-none d-md-block" id="shop-list">
                        Где покупать
                    </div>
                    <div className="ctm-description d-none d-md-block">
                        {storeQuantity ? storeQuan(storeQuantity) + ' для покупок в рассрочку' : ''}
                    </div>
                    <div className="row d-flex d-md-none">
                        <div className="col-8 ctm-title">
                            Где покупать
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <button className="ctm-btn-filter"
                                onClick={this.onShowFilters}>
                                <img src={filter} className="mr-1" alt="filter" />
                                Фильтр
                            </button>
                        </div>
                    </div>
                    <div className="partners-list">
                        {this.props.isLanding ? (
                            <span></span>
                        ) :
                            this.state.showFilters ? (<PartnersFilter
                                onFilter={this.onFilter}
                                defaultValues={this.filterModel}
                                isFiltered={this.isFiltered}
                            />) : null
                        }
                        <PartnersBlock
                            onShowMore={this.showMorePartners}
                            showMoreShopsFlag={this.state.showMoreShopsFlag}
                            partners={partnersCount}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Partners);
